<template>
    <v-card
        flat
    >
        <v-card-text
            v-if="!loading"
        >
            <v-layout wrap>
                <v-flex
                    xs12
                    sm12
                    md4
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="client.current_policy.PolicyMasterID"
                        label="ID"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex
                    xs12
                    sm12
                    md4
                >

                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="client.current_policy.PolicyMasterCode"
                        label="Code"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex
                    xs12
                    sm12
                    md4
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="client.current_policy.Status"
                        label="Status"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>


                <v-flex
                    xs12
                    sm12
                    md6
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="client.current_policy.CommencementDate"
                        label="Commencement"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex
                    xs12
                    sm12
                    md6
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="client.current_policy.WillStatus"
                        label="Will Status"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>


                <v-flex
                    xs12
                >
                    <h3>Plan details</h3>
                </v-flex>

                <v-flex
                    xs12
                    sm12
                    md6
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="client.current_policy.plan_details.product_name"
                        label="Product"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex
                    xs12
                    sm12
                    md6
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="client.current_policy.plan_details.product_plan"
                        label="Plan"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex
                    xs12
                    sm12
                    md6
                >
                    <v-currency-field
                        class="title-branding custom-input"
                        label="Premium"
                        v-model="client.current_policy.plan_details.premium"
                        v-bind="$root.currency_config"
                        type="tel"
                        filled
                        readonly
                    ></v-currency-field>
                </v-flex>

                <v-flex
                    xs12
                    sm12
                    md6
                >
                    <v-currency-field
                        class="title-branding custom-input"
                        label="Value to beneficiaries"
                        v-model="client.current_policy.plan_details.value_beneficiaries_total"
                        v-bind="$root.currency_config_no_decimals"
                        type="tel"
                        filled
                        readonly
                    ></v-currency-field>
                </v-flex>


                <v-flex
                    xs12
                    v-if="files.length"
                >
                    <h3>Files</h3>
                </v-flex>

                <v-flex
                    xs12
                    v-if="files.length"
                >
                    <v-layout
                        wrap
                        row
                    >
                        <v-flex
                            xs12
                            sm12
                            md4
                            v-for="(file, index) in files"
                            :key="index"
                        >
                            <v-card
                                flat
                            >
                                <v-card-text
                                    class="d-flex justify-center align-center"
                                >
                                    <v-btn
                                        icon
                                        class="mr-2"
                                        @click="viewFile(file)"
                                    >
                                        <v-icon
                                            :color="$vuetify.theme.dark ? 'accent' : 'primary'"
                                        >
                                            $mdiEye
                                        </v-icon>
                                    </v-btn>
                                    <div>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <span
                                                    v-on="on"
                                                >
                                                    {{ file.name }}
                                                </span>
                                            </template>
                                            <span>{{ file.pivot.role }}</span>
                                        </v-tooltip>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-text
            v-else
            class="d-flex justify-center align-center mh-300"
        >
            <v-progress-circular
                :size="50"
                color="secondary"
                indeterminate
            ></v-progress-circular>
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        data() {
            return {
                loading: true,
                client: {},

                files: [],
            }
        },
        props: ['itemInfo'],
        name: 'Client-Info',
        mounted() {
            this.client = this.itemInfo;

            this.getFiles();
        },

        methods: {
            getFiles() {
                window.axios.post('/policies/files', {
                    id: this.client.current_policy.PolicyMasterID
                })
                    .then((response) => {
                        this.files = response.data.files;
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            },
            viewFile(file) {
                this.createNewBrowserTab();

                this.openUrlInNewTab(file.url);
            }
        }
    }
</script>
